import React from 'react';
import { Table, Button, DropdownButton, MenuItem } from 'react-bootstrap';
import { getUser } from '../../utils/Common';
import { toProperCase } from '../../utils/Common';

export default function UserTable({ 
  users, 
  caps, 
  userCaps, 
  currentUser, 
  isMobile, 
  handleUserClick, 
  handleAccessChange, 
  getAccessColor, 
  getReadableAccessLevel 
}) {
  return (
    <div style={{ overflowX: 'auto' }}>
      <Table bordered condensed striped hover className="cap-access-table">
        <thead>
          <tr>
            <th className="sticky-left">Employee</th>
            {caps.map(cap => {
              const currentUserCap = userCaps.find(
                uc => uc.userId === currentUser.userId && uc.capId === cap.capId
              );
              const hasAccess = currentUserCap && currentUserCap.accessType === 'OWNER';
              return (
                <th key={cap.capId+'-header'} style={{
                  opacity: hasAccess ? 1 : 0.5,
                  backgroundColor: hasAccess ? 'inherit' : '#f8f9fa',
                  verticalAlign: 'middle',
                  padding: 0
                }}>
                  <Button
                    bsStyle="default"
                    onClick={() => window.location.href = `/caps/${cap.capId}`}
                    style={{
                      width: '100%',
                      textAlign: 'left',
                      backgroundColor: 'transparent',
                      border: 'none',
                      color: '#495057',
                      padding: '8px 12px',
                      fontWeight: 'normal'
                    }}
                  >
                    {cap.name}
                  </Button>
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {users
            .sort((a, b) => {
              if (a.userId === currentUser.userId) return -1;
              if (b.userId === currentUser.userId) return 1;
              return a.email < b.email ? -1 : 1;
            })
            .map(user => (
              <tr key={user.userId} style={{ 
                backgroundColor: user.userId === currentUser.userId ? '#f8f9fa' : 'inherit',
                fontWeight: user.userId === currentUser.userId ? 'bold' : 'normal'
              }}>
                <td className="sticky-left">
                  <Button
                    bsStyle="default"
                    onClick={() => handleUserClick(user.userId)}
                    className={user.role === 'SHARE_CREATE' ? 'warning' : ''}
                    style={{
                      fontWeight: user.userId === currentUser.userId ? 'bold' : 'normal',
                      backgroundColor: user.userId === currentUser.userId ? '#f8f9fa' : 'transparent'
                    }}
                  >
                    {user.role === 'SHARE_CREATE' && (
                      <i className="fas fa-exclamation-circle" />
                    )}
                    {user.firstName ? (user.lastName ? toProperCase(user.firstName) + " " + toProperCase(user.lastName) : toProperCase(user.firstName)) : user.email}
                  </Button>
                </td>
                {caps.map(cap => {
                  const userCap = userCaps.find(
                    uc => uc.userId === user.userId && uc.capId === cap.capId
                  );
                  const currentUserCap = userCaps.find(
                    uc => uc.userId === currentUser.userId && uc.capId === cap.capId
                  );
                  const accessLevel = userCap ? userCap.accessType : 'No Access';
                  const backgroundColor = getAccessColor(accessLevel, user);
                  const isCurrentUser = user.userId === currentUser.userId;
                  const hasAccess = currentUserCap && currentUserCap.accessType === 'OWNER';
                  
                  return (
                    <td key={cap.capId} style={{
                      opacity: hasAccess ? 1 : 0.5,
                      backgroundColor: hasAccess ? 'inherit' : '#f8f9fa'
                    }}>
                      <DropdownButton
                        title={getReadableAccessLevel(accessLevel, user, isMobile)}
                        id={`dropdown-${user.userId}-${cap.capId}`}
                        onSelect={(newType) => handleAccessChange(user.userId, cap.capId, newType)}
                        style={{backgroundColor}}
                        disabled={isCurrentUser || !hasAccess}
                        bsSize={isMobile ? "xs" : "small"}
                      >
                        <MenuItem eventKey="No Access" style={{ backgroundColor: getAccessColor('No Access', user, isMobile)}}>{getReadableAccessLevel('No Access', user, isMobile)}</MenuItem>
                        <MenuItem eventKey="DEMO" style={{ backgroundColor: getAccessColor('DEMO', user, isMobile)}}>{getReadableAccessLevel('DEMO', user, isMobile)}</MenuItem>
                        <MenuItem eventKey="VIEWER" style={{ backgroundColor: getAccessColor('VIEWER', user, isMobile)}}>{getReadableAccessLevel('VIEWER', user, isMobile)}</MenuItem>
                        <MenuItem eventKey="OWNER" style={{ backgroundColor: getAccessColor('OWNER', user, isMobile)}}>{getReadableAccessLevel('OWNER', user, isMobile)}</MenuItem>
                        {getUser().role==='ADMIN' && <MenuItem eventKey="SALES_DEMO" style={{ backgroundColor: getAccessColor('SALES_DEMO', user, isMobile)}}>{getReadableAccessLevel('SALES_DEMO', user, isMobile)}</MenuItem>}
                      </DropdownButton>
                    </td>
                  );
                })}
              </tr>
            ))}
        </tbody>
      </Table>
    </div>
  );
} 